/** Japanese Workforce & Education Translations */
export const workforce = {
  workforce: {
    pageTitle: "労働力・教育ディメンション",
    weightInFII: "FIIでの重み",
    heroSubtitle: "経済的機会のためのスキルで若者を装備（18-40歳）",
    quote: "若年労働者の23%が学歴に対して不完全雇用状態にありますが、将来の仕事の85%がデジタルスキルを必要とします。教育と機会の間のギャップは学習者の不足ではなく、質の高い雇用への整合的でアクセス可能な経路の不足です。",
    fiiWeightDistribution: "FII重み配分",
    mentalHealth: "メンタルヘルス",
    workforceLabel: "労働力",
    entrepreneurship: "起業家精神",
    understandCrisis: "危機を理解する",
    crisisTitle: "労働力・教育危機の数字",
    crisisSubtitle: "世界中の若者の雇用可能性と教育に影響を与える重要な統計",
    crisis: {
      inThree: "人に1人",
      stat1Label: "世界の若年失業率（18-24歳）対 成人5.8%",
      stat2Label: "世界中で教育・雇用・訓練に就いていない（NEET）若者",
      stat3Label: "学歴に対して不完全雇用の労働者",
      stat4Label: "2030年までにデジタルスキルを必要とする仕事",
      stat5Label: "世界平均の高等教育入学率（範囲：15%-78%）",
      stat6Label: "サブサハラアフリカで正規労働力外の若者",
      stat7Label: "デジタルスキル開発の1日平均時間",
      stat8Label: "新興市場対先進国での失業率の高さ",
    },
    severity: {
      crisis: "危機",
      severe: "深刻",
      concerning: "懸念",
    },
    coreProblem: "核心的問題",
    coreProblemDesc: "メンタルヘルス（個人の幸福度によって変動）とは異なり、労働力と教育のギャップは構造的障壁によって引き起こされます：質の高いトレーニングへのアクセス、デジタルインフラの利用可能性、教えられたスキルと労働市場の整合性、特定の能力に対する雇用者の需要。これらはJCIが大規模に取り組めば解決可能な問題です。",
    fiiTitle: "FII労働力方法論",
    fiiSubtitle: "労働力スコア = 将来影響指数の30%",
    subWeight: "サブウェイト",
    globalAverage: "世界平均",
    highest: "最高",
    lowest: "最低",
    fii: {
      employmentRate: "若年雇用率",
      employmentRateDef: "正規雇用（不安定雇用を除く）の18-40歳の割合",
      employmentHighest: "北欧諸国（85-90%）",
      employmentLowest: "サブサハラアフリカ（45-55%）",
      skillsAlignment: "スキル整合性",
      skillsAlignmentDef: "スキルが仕事の要件に一致している労働者の割合",
      skillsHighest: "スイス、ドイツ（70-75%）",
      skillsLowest: "南アジア（30-35%）",
      educationAccess: "教育アクセス",
      educationAccessDef: "高等教育と職業訓練プログラムへの複合アクセス",
      educationHighest: "韓国、フィンランド（78%）",
      educationLowest: "ニジェール、チャド（15%）",
    },
    regionalTitle: "地域別労働力スコア",
    regionalSubtitle: "FII労働力ディメンション：地域パフォーマンス",
    regions: {
      europe: "ヨーロッパ",
      asiaPacific: "アジアと太平洋",
      americas: "アメリカ",
      africaMe: "アフリカ・中東",
    },
    status: {
      good: "良好",
      moderate: "中程度",
      atRisk: "リスクあり",
    },
    regional: {
      europeDrivers: "デュアルトレーニングシステム、強力な職業教育",
      europeOpportunity: "JCIトレーニングプログラムのモデル",
      asiaPacificDrivers: "経済的変動：日本/韓国高い、南アジア低い",
      asiaPacificOpportunity: "デジタルリテラシーとテックスキルパートナーシップ",
      americasDrivers: "北米強い、ラテンアメリカにギャップあり",
      americasOpportunity: "JCI + CYEプログラムのスケーラビリティ",
      africaMeDrivers: "若い人口、インフラ不足",
      africaMeOpportunity: "最大の潜在的影響—モバイルファーストトレーニング",
    },
    employment: "雇用",
    skillsLabel: "スキル",
    education: "教育",
    projectionTitle: "2024年対2040年予測",
    skillsTitle: "グローバルスキルランドスケープ",
    skillsSubtitle: "スキルの需給ギャップ分析",
    hardSkills: "ハードスキル",
    softSkills: "ソフトスキル",
    supply: "供給",
    demand: "需要",
    skillNames: {
      dataAnalytics: "データ分析",
      cloudComputing: "クラウドコンピューティング",
      aiMl: "AI/機械学習",
      cybersecurity: "サイバーセキュリティ",
      projectMgmt: "プロジェクト管理",
      criticalThinking: "クリティカルシンキング",
      communication: "コミュニケーション",
      adaptability: "適応力",
      leadership: "リーダーシップ",
      creativity: "創造性",
    },
    deepDiveTitle: "地域詳細分析",
    deepDiveSubtitle: "JCI地域別の労働力・教育の詳細分析",
    strengths: "強み",
    challenges: "課題",
    jciOpportunity: "JCI機会",
    deepDive: {
      europe: {
        strength1: "デュアル教育システム（ドイツ、オーストリア、スイス）",
        strength2: "R&Dとイノベーションへの高い投資",
        strength3: "強力な労働保護と福利厚生",
        challenge1: "労働力の高齢化",
        challenge2: "一部地域でのデジタルスキルギャップ",
        challenge3: "南欧での若年失業",
        opportunity: "デュアルトレーニングモデルを他の地域に輸出",
      },
      asiaPacific: {
        strength1: "教育に対する高い文化的価値観",
        strength2: "技術の急速な採用",
        strength3: "若く成長する労働力",
        challenge1: "国間のアクセス不平等",
        challenge2: "教育と市場の不一致",
        challenge3: "正規雇用への高い競争",
        opportunity: "モバイルファーストのデジタルスキルプログラム",
      },
      americas: {
        strength1: "強力なイノベーションエコシステム（米国、カナダ）",
        strength2: "高まる起業家精神",
        strength3: "人材の多様性",
        challenge1: "質の高い教育へのアクセス不平等",
        challenge2: "高等教育の高コスト",
        challenge3: "卒業生の不完全雇用",
        opportunity: "ラテンアメリカでJIB + CYEプログラムを拡大",
      },
      africaMe: {
        strength1: "世界で最も若い人口",
        strength2: "高い起業家志向",
        strength3: "デジタルエコシステムの成長",
        challenge1: "限られた教育インフラ",
        challenge2: "高い若年失業率（14-16%）",
        challenge3: "深刻な資金ギャップ",
        opportunity: "若者向けモバイルファーストトレーニングとマイクロファイナンス",
      },
    },
    initiativesTitle: "JCI現在のイニシアチブ",
    initiativesSubtitle: "JCIの労働力・教育プログラム",
    program: "プログラム",
    reach: "リーチ",
    target: "対象者",
    statusLabel: "ステータス",
    initiatives: {
      jibName: "JCIジュニアインビジネス（JIB）",
      jibTarget: "若手起業家（18-30歳）",
      jibDesc: "ビジネスリテラシートレーニングとスタートアップ立ち上げ",
      cyeName: "クリエイティブヤングアントレプレナーシップ（CYE）",
      cyeTarget: "クリエイティブな若者（16-25歳）",
      cyeDesc: "クリエイティブスキルと起業家精神プログラム",
      digitalName: "JCIデジタルアカデミー",
      digitalTarget: "全ての若者（18-40歳）",
      digitalDesc: "デジタルスキルトレーニングとテクノロジーリテラシー",
      mentoringName: "JCIメンタリングネットワーク",
      mentoringTarget: "若手プロフェッショナル（22-35歳）",
      mentoringDesc: "キャリア開発のためのメンター・メンティー接続",
      riseName: "RISEプロジェクト",
      riseTarget: "リスクのあるコミュニティ",
      riseDesc: "雇用に焦点を当てたコミュニティインパクトプロジェクト",
      statusActive: "アクティブ",
      statusGrowing: "成長中",
      statusExpanding: "拡大中",
    },
    outcomesTitle: "成果とケーススタディ",
    outcomesSubtitle: "JCI労働力プログラムの測定可能な影響",
    cases: {
      paraguayCountry: "パラグアイ",
      paraguayTitle: "JCIアスンシオンデジタルスキル",
      paraguayOutcome: "失業中の若者向けデジタルトレーニングプログラムが高い就職率を達成",
      paraguayMetric: "就職率",
      syriaCountry: "シリア（難民）",
      syriaTitle: "JCI難民スキルイニシアチブ",
      syriaOutcome: "近隣諸国でのシリア難民青年向け職業訓練",
      syriaMetric: "訓練を受けた若者",
      boliviaCountry: "ボリビア",
      boliviaTitle: "JCIサンタクルスアントレプレンド",
      boliviaOutcome: "農村コミュニティの若者向けマイクロ起業プログラム",
      boliviaMetric: "立ち上げた企業",
    },
    actionsTitle: "JCIへの推奨アクション",
    actionsSubtitle: "労働力ギャップを埋めるための戦略的優先事項",
    actions: {
      action1Title: "デジタルアカデミーを拡大",
      action1Desc: "デジタルスキルトレーニングを全地域に拡大、アフリカ/中東を優先",
      action1Effort: "12-18ヶ月",
      action1Impact: "3倍のリーチ",
      action2Title: "企業パートナーシップ",
      action2Desc: "雇用経路を確保するための雇用者とのパートナーシップを開発",
      action2Effort: "6-12ヶ月",
      action2Impact: "雇用可能性+40%",
      action3Title: "職業教育",
      action3Desc: "市場に整合した職業訓練プログラムを作成",
      action3Effort: "18-24ヶ月",
      action3Impact: "持続可能なモデル",
      action4Title: "大規模メンタリング",
      action4Desc: "メンタリングネットワークを50,000以上のアクティブな接続に拡大",
      action4Effort: "24-36ヶ月",
      action4Impact: "キャリア開発",
      action5Title: "認定資格",
      action5Desc: "グローバル雇用者に認められるJCI認定を開発",
      action5Effort: "18-24ヶ月",
      action5Impact: "グローバルな信頼性",
      action6Title: "マイクロファイナンス基金",
      action6Desc: "新興市場の若手起業家向けマイクロファイナンス基金を設立",
      action6Effort: "12-18ヶ月",
      action6Impact: "資本へのアクセス",
    },
    ctaTitle: "労働力はイネーブラー",
    ctaDescription: "労働力と教育はメンタルヘルス（基盤）と起業家精神（アクセラレーター）を結びつけます。雇用されている若者はより良いメンタルヘルス、より多くの自信、そしてビジネスを始める能力を持っています。",
    exploreFII: "FIIを探索",
    exploreMentalHealth: "メンタルヘルスを探索",
    dataSources: { title: "データソース" },
  },
} as const;
